export class AzureEndpointDisplay {
  Id: number;
  EndpointName: string;
  FullyQualifiedUrl: string;
  PharCode: string;
  Pharmacy: string;
  AzureAccountId: number;
  AzureAccount: string;
  AzureNamespaceId: number;
  AzureNamespace: string;
  AzureEndpointsCountForNamesapce: number;
  PharmacyNpi: string;
  StreetAddress: string;
  City: string;
  State: string;
  ZIPCode: string;
  Active: boolean;
  SubscriptionId: string;
  ResourceGroup: string;

  constructor() { }
}

export class AzureEndpoint {
  Id: number;
  EndpointName: string;
  PharmacyNpi: string;
  AzureAccountIdFk: number;
  AzureNamespaceIdFk: number;
  FullyQualifiedUrl: string;
  PharmacyGroupIdFk: number;
  Active: boolean;

  constructor() {
    this.Active = true;
  }
}
